module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_star.a97ae.png";